import { useQuery } from '@tanstack/react-query';
import { graphql } from '../gql/gql';
import { graphqlRequest, shouldRetryQuery } from '../utils/graphqlClient';

// Define the GraphQL query for fetching trip skills
const tripSkillsByTripQuery = graphql(/* GraphQL */ `
  query tripSkillsByTrip($tripId: Int!) {
    tripSkills(tripId: $tripId) {
      skillId
      skillName
    }
  }
`);

// Custom hook for fetching trip skills based on tripId
const useTripSkills = (tripId: number, shouldFetch: boolean) => {
  const { data, isLoading, error } = useQuery<{
    tripSkills: Array<{ skillId: number; skillName: string }>;
  }>({
    queryKey: ['tripSkills', tripId],
    queryFn: async () => graphqlRequest(tripSkillsByTripQuery, { tripId }), // Public endpoint, no auth needed
    enabled: !!shouldFetch,
    staleTime: 3600000, // 1 hour
    retry: shouldRetryQuery,
  });

  return {
    tripSkills: data?.tripSkills || [],
    isLoading,
    error,
  };
};

export default useTripSkills;
